module.exports = __webpack_public_path__ + "public/SiteImages/warrow.png?55311d0b";